<template>
  <div class="column is-9">
    <div class="loading" v-if="loading">
      <pulse-loader :loading="loading"></pulse-loader>
    </div>
    <div v-else-if="rubric && loading === false" class="is-border is-radius-large has-bg-white content content-guide">
      <div class="column is-border-bottom is-paddingless-bottom">
        <h1>{{rubric.name}}</h1>
        <span class="intro-guide-faq">{{rubric.abstract}}</span>
        <div class="media" style="text-align:center">
          <img :src="rubric.media" style="text-align :center">
        </div>
        <br>
      </div>
        <ul class="liste-themes-guide columns is-gapless is-multiline is-margin-bottom-large">
          <page-tile :key="p.id" :page="p" :rubric="rubric" v-for="p in pages"></page-tile>
        </ul>
    </div>
  </div>
</template>

<script>
// import showdown from 'showdown'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import { mapState } from 'vuex'
import PageTile from '../components/PageTile.vue'
import { objectPage, objectRubric } from '../utils.js'
// const converter = new showdown.Converter()
// const contentful = require('contentful')

export default {
  name: 'Rubric',
  components: {
    PageTile,
    PulseLoader
  },
  data () {
    return {
      loading: false,
      rubric: null,
      error: null,
      pages: []
    }
  },
  computed: {
    ...mapState(['rubrics', 'contentfullClient', 'profil'])
  },
  watch: {
    $route: 'fetchData'
  },
  methods: {
    checkprofile (rubric) {
      if (rubric.destinations !== undefined) {
        if (rubric.destinations.includes(this.profil) === false) {
          this.$router.replace('/error')
        }
      }
    },
    fetchData () {
      this.pages = []
      this.rubric = null
      this.loading = true
      this.contentfullClient.getEntries({
        content_type: 'faqSubject',
        'fields.redirectId': this.$route.params.rubricId,
        include: 2
      }).then(response => {
        let item = response.items[0]
        console.log(response.items)
        this.loading = false
        this.rubric = objectRubric(item)
        console.log(this.rubric)
        console.log(this.rubric.destinations)
        this.checkprofile(this.rubric)
        item.fields.contents.forEach(e => {
          let content = e
          let page = objectPage(content)
          if (content.fields.destinations === null || content.fields.destinations === undefined) {
            this.pages.push(page)
          } else if (content.fields.destinations.includes(this.profil) && this.profil !== null) {
            this.pages.push(page)
          }
        })
      }).catch(err => {
        console.log(err)
      })
    }
  },
  created () {
    this.fetchData()
  }
}
</script>
